import React from "react";
import cn from "classnames";
import * as PopoverPrimitive from "@radix-ui/react-popover";
import { useComboxContext } from "~/components/shared/Combox/ComboxContext";

export interface ComboxPopoverProps extends PopoverPrimitive.PopoverContentProps {
  children?: React.ReactNode;
  className?: string;
}

export const ComboxPopover = ({ children, className, ...props }: ComboxPopoverProps) => {
  const { contentRef, searchInputRef } = useComboxContext();

  return (
    <PopoverPrimitive.Portal forceMount={props.forceMount}>
      <PopoverPrimitive.Content
        ref={contentRef}
        className={cn(
          "shadow-depth-800 outline-hidden z-50 overflow-hidden rounded-sm bg-white",
          "w-[--radix-popper-anchor-width]",
          className,
        )}
        role="listbox"
        side="bottom"
        sideOffset={1}
        align="start"
        collisionPadding={10}
        onOpenAutoFocus={(event) => {
          event.preventDefault();
          if (searchInputRef.current) {
            searchInputRef.current.focus();
          }
        }}
        forceMount={props.forceMount}
        {...props}
      >
        <div className="flex max-h-96 flex-col">{children}</div>
      </PopoverPrimitive.Content>
    </PopoverPrimitive.Portal>
  );
};

export default ComboxPopover;
